import React from "react";

const ApproveContext = React.createContext();
ApproveContext.displayName = "ApproveContext";

export default ApproveContext;
